<template>
  <div class="relative w-full h-full pt-[1.2rem]">
    <div class="relative flex flex-col h-full">
      <!-- title -->
      <div class="title text-[white] text-[1.4rem] uppercase leading-[1.6rem] shrink-0">
        <img src="/images/logo.png" class="w-[2rem] mb-[0.5rem] center-horizontal" />
        <p v-show="name != ''">{{ text.title1 }} {{ name }}{{ text.title12 ? ` ${text.title12}` : "" }},</p>
        <p class="">{{ text.title2 }}</p>
      </div>
      <!-- toggle -->
      <div class="toggle relative shrink-0 w-[16rem] mt-[1rem] h-[3rem] p-[0.2rem] center-horizontal bg-[#fbfaf8] rounded-full flex justify-center items-center">
        <div @click="change('day')" class="relative rounded-l-full text-left w-[50%] h-full flex justify-between items-center px-[1rem]" :style="{ backgroundColor: type == 'day' ? '#c2ad6c' : '' }">
          <img class="w-[1rem]" :src="`images/icon-day${type == 'day' ? '-active' : ''}.png`" />
          <p class="w-full text-center uppercase mt-[0.2rem] text-[1rem]">{{ text.day }}</p>
        </div>
        <div @click="change('night')" class="relative rounded-r-full text-right right-0 w-[50%] h-full flex justify-between items-center px-[1rem]" :style="{ backgroundColor: type == 'night' ? '#c2ad6c' : '' }">
          <p class="w-full text-center uppercase mt-[0.2rem] text-[1rem]">{{ text.night }}</p>
          <img class="w-[1rem]" :src="`images/icon-night${type == 'night' ? '-active' : ''}.png`" />
        </div>
      </div>
      <!-- products -->
      <div class="relative h-full mt-[1rem] mb-[5.4rem] flex-1">
        <div class="relative h-full">
          <img src="images/line-day.png" class="absolute center-horizontal h-full" v-show="type == 'day'" />
          <img src="images/line-night.png" class="absolute center-horizontal h-full" v-show="type == 'night'" />

          <!-- products day -->
          <div class="absolute w-full top-0 h-full overflow-y-scroll overflow-x-hidden items-scroll" v-show="type == 'day'">
            <div class="flex justify-center relative top-0 w-full" ref="dayItemsContainerEl">
              <div class="absolute top-0 w-fit flex items-center" v-for="(value, index) in showProductsDay" :key="index" ref="dayItemsEl">
                <div class="label absolute mt-[5px]">
                  <p class="text-[1rem] leading-[1rem] item-text-top uppercase" v-html="value.name"></p>
                  <p v-show="value.text != ''" class="text-[0.9rem] item-text-bottom leading-[1rem] text-[#354d75] uppercase" v-html="value.text"></p>
                  <div v-show="value.img != []" class="flex mt-[3px] label-img">
                    <img v-for="x in value.img[1]" :key="x" :src="`images/${value.img[0]}.png`" class="w-[1.5rem]" />
                  </div>
                </div>
                <div class="relative flex justify-center items-center w-[9rem] aspect-square">
                  <img src="images/bubble-small-day.png" class="w-full" />
                  <div class="absolute w-[4rem] aspect-square">
                    <img :src="`images/product${value.product}/product-day-${value.id}.png`" class="w-full h-full object-contain" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- products night -->
          <div class="absolute w-full top-0 h-full overflow-y-scroll overflow-x-hidden items-scroll" v-show="type == 'night'">
            <div class="flex justify-center relative top-0 w-full" ref="nightItemsContainerEl">
              <div class="absolute top-0 w-fit flex items-center" v-for="(value, index) in showProductsNight" :key="index" ref="nightItemsEl">
                <div class="label absolute mt-[5px]">
                  <p class="text-[1rem] leading-[1rem] item-text-top uppercase" v-html="value.name"></p>
                  <p v-show="value.text != ''" class="text-[0.9rem] item-text-bottom leading-[1rem] text-[#354d75] uppercase" v-html="value.text"></p>
                  <div v-show="value.img != []" class="flex mt-[3px] label-img">
                    <img v-for="x in value.img[1]" :key="x" :src="`images/${value.img[0]}.png`" class="w-[1.5rem]" />
                  </div>
                </div>
                <div class="relative flex justify-center items-center w-[9rem] aspect-square">
                  <img src="images/bubble-small-night.png" class="w-full" />
                  <div class="absolute w-[4rem] aspect-square">
                    <img :src="`images/product${value.product}/product-night-${value.id}.png`" class="w-full h-full object-contain" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- button -->
      <div @click="openTab()" class="h-[3rem] w-fit px-[1rem] bg-[#c2ad6a] rounded-[0.5rem] text-white flex justify-center items-center center-horizontal absolute bottom-[1.5rem]">
        <span class="uppercase text-[0.88rem] tracking-[0.05rem] visitBtn">{{ text.btn }}</span>
      </div>
    </div>

    <!-- tab -->
    <div ref="tabEl" class="absolute flex items-center top-[50%] translate-y-[-42%] right-0 w-[10rem]">
      <div ref="showTabEl" class="w-full">
        <img :src="`images/tab-show-${lang}.png`" class="w-full" />
        <div class="w-full h-[11%] absolute bottom-[0] center-horizontal" @click="toggleTab('hide')"></div>
      </div>
      <div ref="hideTabEl" class="absolute right-0 w-[3rem]" @click="toggleTab('show')">
        <img src="images/tab-hide.png" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import CryptoJS from "crypto-js";

export default {
  name: "App",
  components: {},
  data() {
    return {
      type: "day",
      name: "",
      showProductsDay: [],
      showProductsNight: [],
      lang: "en",
      text: {},
    };
  },
  methods: {
    openTab() {
      window.open("https://www.cledepeau-beaute.com", "_blank");
    },
    change(type) {
      this.type = type;
    },
    resize() {
      var width = window.innerWidth > 300 ? window.innerWidth : 300;
      var height = window.innerHeight > 500 ? window.innerHeight : 500;
      var widthRatio = width / 375;
      var heightRatio = height / 667;
      var newFontSize;

      if (widthRatio < heightRatio) {
        newFontSize = 12 * widthRatio;
      } else {
        newFontSize = 12 * heightRatio;
      }

      document.documentElement.style.fontSize = newFontSize + "px";
      // this.displayDeviceType();
    },
    toggleTab(type) {
      if (type == "show") {
        gsap.to(this.$refs.showTabEl, { xPercent: 0, ease: "expo.out", duration: 0.5 });
        gsap.to(this.$refs.hideTabEl, { xPercent: 100, ease: "expo.out", duration: 0.5 });
      } else {
        gsap.to(this.$refs.showTabEl, { xPercent: 100, ease: "expo.out", duration: 0.5 });
        gsap.to(this.$refs.hideTabEl, { xPercent: 0, ease: "expo.out", duration: 0.5 });
      }
    },
    async importFonts() {
      import(`./assets/css/style-${this.lang}.css`);
      this.productsDay = (await import(`./product-${this.lang}/products-day.json`)).default;
      this.productsNight = (await import(`./product-${this.lang}/products-night.json`)).default;
      this.text = (await import(`./product-${this.lang}/text.json`)).default;
    },
    decryptString(encrypted) {
      const decoded = decodeURIComponent(encrypted);
      const bytes = CryptoJS.AES.decrypt(decoded, "CPB");
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted;
    },
    async setItems() {
      let params = new URLSearchParams(window.location.search);
      let data = params.get("data");

      if (!data) {
        return this.importFonts();
      }

      const decrypted = this.decryptString(data);

      try {
        const products = JSON.parse(decrypted);

        this.name = products.name;
        this.lang = products.lang;

        await this.importFonts();

        products.day.forEach((el) => {
          const split = el.split("-");
          const item = this.productsDay[split[0]].find((obj) => obj.id == split[1]);
          item.product = split[0];
          this.showProductsDay.push(item);
        });

        products.night.forEach((el) => {
          const split = el.split("-");
          const item = this.productsNight[split[0]].find((obj) => obj.id == split[1]);
          item.product = split[0];
          this.showProductsNight.push(item);
        });

        this.$nextTick(() => {
          ["day", "night"].forEach((type) => {
            const items = this.$refs[`${type}ItemsEl`];
            if (!items) return;
            for (let i = 0; i < items.length; i++) {
              const el = items[i];
              const text = el.querySelector(".label");
              const img = el.querySelector(".label-img");

              if (i % 2 == 0) {
                gsap.set(el, { y: `${5.4 * i}rem`, x: "-2.2rem" });
                gsap.set(text, { textAlign: "right", right: "8.3rem", left: "unset" });
                gsap.set(img, { justifyContent: "end" });
              } else {
                gsap.set(el, { y: `${5.4 * i}rem`, x: "2.2rem" });
                gsap.set(text, { textAlign: "left", left: "8.3rem", right: "unset" });
                gsap.set(img, { justifyContent: "start" });
              }
            }
          });
        });
      } catch (error) {
        return this.importFonts();
      }
    },
  },
  mounted() {
    this.setItems();

    this.resize();
    window.addEventListener("resize", this.resize, true);

    this.$nextTick(() => {
      gsap.set(this.$refs.showTabEl, { xPercent: 100 });
      gsap.set(this.$refs.hideTabEl, { xPercent: 0 });
    });
  },
};
</script>

<style>
html,
body {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 12px;
  font-family: "cronos";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}
#app {
  text-align: center;
  background-image: url("./../public/images/bg.png");
  background-size: cover;
  position: relative;
  width: 100%;
  height: 100%;
}
.center-horizontal {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}
.overflow-y-scroll::-webkit-scrollbar {
  display: none !important;
}
</style>
